// import { combineReducers } from 'redux';
import { combineReducers } from '@reduxjs/toolkit';
import addBalanceReducer from './addBalanceSlice';
import profileReducer from './profileSlice';

export const accountReducer = combineReducers({
	addBalance: addBalanceReducer,
	profile: profileReducer
});
